import { Modals } from "@models/enums";
import { ModalStoreFactory } from "@utils/modal-store.factory";

export const ModalStorePortfoliosEditName = ModalStoreFactory<{ portfolio: Nullable<Portfolios.TileData> }>(
  Modals.PORTFOLIOS_EDIT_NAME,
  { portfolio: null }
);
